import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Loader2, XCircle } from 'lucide-react';
import API_BASE from '../../utils/apiBase';
import TenantWelcomeSplash from '../../components/portal/TenantWelcomeSplash';

const API = API_BASE;

const firstNameOf = (fullName) => String(fullName || '').trim().split(/\s+/)[0] || '';

export default function ClientVerifyPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [error, setError] = useState('');
  const [organisation, setOrganisation] = useState(null);
  const [contact, setContact] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setError('No login token. Request a new link.');
      return;
    }
    fetch(`${API}/client/verify-login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    })
      .then((r) => r.json().then((d) => ({ ok: r.ok, d })))
      .then(({ ok, d }) => {
        if (ok && d.access_token) {
          localStorage.setItem('clientToken', d.access_token);
          localStorage.setItem('clientOrg', JSON.stringify(d.organisation));
          localStorage.setItem('clientContact', JSON.stringify(d.contact));
          setOrganisation(d.organisation || null);
          setContact(d.contact || null);
          setStatus('welcome');
        } else {
          setStatus('error');
          setError(d.detail || 'Invalid or expired link');
        }
      })
      .catch(() => {
        setStatus('error');
        setError('Could not verify login');
      });
  }, [searchParams]);

  if (status === 'welcome') {
    const tenantName = organisation?.name || organisation?.display_name || organisation?.brand_name || '';
    return (
      <TenantWelcomeSplash
        tenantName={tenantName}
        logoUrl={organisation?.logo_url || ''}
        primaryColour={organisation?.primary_colour || '#065F46'}
        firstName={firstNameOf(contact?.name)}
        audienceLabel="Client Portal"
        message="Your service information is ready."
        subMessage="Opening your Client Hub…"
        continueLabel="Open Client Hub"
        autoAdvanceMs={1200}
        onContinue={() => navigate('/client/hub')}
      />
    );
  }

  return (
    <div className="min-h-screen bg-emerald-950 flex items-center justify-center p-4">
      <div className="max-w-sm w-full bg-white rounded-2xl p-8 text-center">
        {status === 'verifying' && (
          <>
            <Loader2 className="h-10 w-10 animate-spin text-emerald-600 mx-auto mb-4" />
            <p className="font-medium">Opening your Client Hub…</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
            <p className="font-medium text-red-700">{error}</p>
            <Link to="/client/login" className="text-emerald-700 text-sm mt-4 inline-block underline">Request new link</Link>
          </>
        )}
      </div>
    </div>
  );
}
